import card1 from "../../../assets/new_design/card1.png";
import card2 from "../../../assets/new_design/card2.png";
import card3 from "../../../assets/new_design/card10.png";
import card4 from "../../../assets/new_design/card5.png";
import card5 from "../../../assets/new_design/card6.png";
import card6 from "../../../assets/new_design/card4.png";
import card7 from "../../../assets/new_design/card3.png";
import card8 from "../../../assets/new_design/card12.png";
import card9 from "../../../assets/new_design/card11.png";
import card10 from "../../../assets/new_design/card7.png";
import card11 from "../../../assets/new_design/card8.png";
import card12 from "../../../assets/new_design/card9.png";
import card13 from "../../../assets/new_design/card13.webp";

import AnimatedDemo from "../../../components/AnimatedDemo";
import PaperSearch2Demo from "../../../components/papersearch2demo";
import SearchPapersDemo from "../../../components/SearchPapersDemo";
import ChatPdfDemo from "../../../components/ChatPdfDemo";
import PdfAnalysisDemo from "../../../components/PdfAnalysisDemo";
import PaperInsightsDemo from "../../../components/PaperInsightsDemo";
import CitationGeneratorDemo from "../../../components/CitationGeneratorDemo";
import CitationManagementDemo from "../../../components/CitationManagementDemo";
import HeroDocument from "../../../components/HeroDocument";
import WritingEnhancerDemo from "../../../components/WritingEnhancerDemo";
import EssayWritingDemo from "../../../components/EssayWritingDemo";
import ZoteroImportDemo from "../../../components/ZoteroImportDemo";

const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};

export const featuresCard = [
  {
    id: createSlug("Literature Review"),
    title: "Literature Review",
    img: card1,
    demo: AnimatedDemo,
    demoHeight: 470,
    description: "Generate structured literature reviews by simply entering your research topic or question. ResearchPal searches across millions of academic papers, synthesizes findings, and produces citation-backed content ready for your research workflow.",
    rowHeight: "585px",
    buttonText: "Generate Review"
  },
  {
    id: createSlug("Search Papers"),
    title: "Search Papers",
    img: card2,
    demo: PaperSearch2Demo,
    demoHeight: 500,
    description: "Discover relevant research papers using intelligent, domain-specific search across millions of academic sources. Save papers, explore citations and references, and build your research foundation faster.",
    rowHeight: "585px",
    buttonText: "Discover Papers"
  },
  {
    // No /features detail page: the card opens the public Claim Check page
    id: "claim-check",
    link: "/claim-check",
    title: "Claim Check",
    img: card13,
    description: "Check whether published research supports a claim, refutes it, or shows mixed findings. Each evidence card shows the exact sentence behind its label, and retracted papers are flagged separately.",
    rowHeight: "585px",
    buttonText: "Check a Claim"
  },
  {
    id: "connectedpapers",
    // title: "Mind Map Similarity Graphs",
    title: "Connected Papers",
    img: card7,
    demo: SearchPapersDemo,
    demoHeight: 520,
    description: "Explore how research papers connect through citations, references, and shared topics using an interactive visual graph for deeper discovery. Navigate research relationships, uncover trends, and find relevant papers faster.",
    rowHeight: "585px",
    buttonText: "Explore Graph"
  },
  {
    id: createSlug("Chat With PDF"),
    title: "Chat With PDF",
    img: card4,
    demo: ChatPdfDemo,
    demoHeight: 340,
    description: "Upload or import PDFs and interact with research papers using AI. Ask questions, extract insights, and explore content faster with context-aware responses.",
    rowHeight: "585px",
    buttonText: "Start Chatting"
  },
  {
    id: createSlug("Analyze & Remix Within PDF Chat"),
    title: "Analyze & Remix Within PDF Chat",
    img: card5,
    demo: PdfAnalysisDemo,
    demoHeight: 480,
    description: "Screenshot any figure or visual from your PDF and let ResearchPal analyze, explain, and redesign it into clean, high-quality visuals using AI. Turn research visuals into presentation-ready graphics in seconds.",
    rowHeight: "585px",
    buttonText: "Analyze Visuals"
  },
  {
    id: createSlug("Paper Insights"),
    title: "Paper Insights",
    img: card6,
    demo: PaperInsightsDemo,
    demoHeight: 340,
    description: "Analyze research papers and extract key information such as methodology, findings, limitations, and contributions. Compare multiple papers and generate structured insights to accelerate your understanding.",
    rowHeight: "563px",
    buttonText: "Extract Insights"
  },
  {
    id: createSlug("Citation Generator"),
    title: "Citation Generator",
    img: card10,
    demo: CitationGeneratorDemo,
    demoHeight: 330,
    description: "Generate accurate academic citations using URLs, DOIs, titles, or identifiers. Convert citations into multiple formats and save them directly to your research workspace.",
    rowHeight: "563px",
    buttonText: "Generate Citations"
  },
  {
    id: createSlug("Citation Management"),
    title: "Citation Management",
    img: card11,
    demo: CitationManagementDemo,
    demoHeight: 330,
    description: "Store, manage, and format all your citations in one place. Automatically save citations from essays, literature reviews, uploads, and citation generation.",
    rowHeight: "563px",
    buttonText: "Manage Citations"
  },
  {
    id: createSlug("AI-Powered Editor Tools"),
    title: "AI-Powered Editor Tools",
    img: card12,
    demo: HeroDocument,
    demoHeight: 340,
    demoProps: { height: 340 },
    description: "Enhance your writing directly inside the document editor with context-aware AI tools designed for academic writing.",
    rowHeight: "563px",
    buttonText: "Enhance Writing"
  },
  {
    id: createSlug("Paraphraser & Writing Enhancer"),
    title: "Paraphraser & Writing Enhancer",
    img: card3,
    demo: WritingEnhancerDemo,
    demoHeight: 330,
    description: "Improve your academic writing with AI-powered editing tools including paraphrasing, summarization, tone adjustment, and translation.",
    rowHeight: "563px",
    buttonText: "Refine Text"
  },
  {
    id: createSlug("Research Library & Integrations"),
    title: "Research Library & Integrations",
    img: card8,
    demo: ZoteroImportDemo,
    demoHeight: 470,
    description: "Upload, organize, and import research papers from multiple sources including Zotero and Mendeley. Access files, extract insights, and manage your research in one centralized library.",
    rowHeight: "563px",
    buttonText: "Organize Library"
  },
  {
    id: createSlug("Essay Writing"),
    title: "Essay Writing",
    img: card9,
    demo: EssayWritingDemo,
    demoHeight: 480,
    description: "Generate structured essays with headings, citations, and customizable formats. Define topic, essay type, and length to instantly create well-structured academic content.",
    rowHeight: "563px",
    buttonText: "Write Essay"
  }
];
